import { jsPDF } from "jspdf";

async function urlToBase64(url) {

  const response =
    await fetch(url);

  const blob =
    await response.blob();

  return await new Promise(

    resolve => {

      const reader =
        new FileReader();

      reader.onloadend =
        () =>
          resolve(
            reader.result
          );

      reader.readAsDataURL(
        blob
      );

    }

  );

}

export async function
generateReceiptPDF({

  clinicName = "VexaDent",

  clinicLogo,

  clinicAddress,

  clinicPhone,

  clinicRFC,

  clinicEmail,

  patientName,

  treatment,

  paymentMethod,

  totalTreatment,

  paymentAmount,

  remainingBalance,

  totalPaid,

  folio,

  paymentDate,

  loadLogo = urlToBase64

}) {

  let logoBase64 =
    clinicLogo?.startsWith("data:image")
        ? clinicLogo
        : null;

  if (

      !logoBase64 &&

      clinicLogo

  ) {

      try {

          logoBase64 =
              await loadLogo(
                  clinicLogo
              );

      } catch(error) {

          console.error(
              "Error cargando logo:",
              error
          );

      }

  }

  const pdf =
    new jsPDF();

  // =====================
  // LOGO
  // =====================

  if (logoBase64) {

    try {

      pdf.addImage(

        logoBase64,

        "PNG",

        15,

        10,

        30,

        30

      );

    } catch(error) {

      console.error(
        "Error insertando logo:",
        error
      );

    }

  }

  // =====================
  // ENCABEZADO
  // =====================

  pdf.setFontSize(18);

  pdf.text(

    clinicName || "",

    55,

    18

  );

  pdf.setFontSize(10);

  const direccionTexto =

      typeof clinicAddress === "string"

          ? clinicAddress

          : [

              clinicAddress?.calle,

              clinicAddress?.numeroExterior,

              clinicAddress?.numeroInterior
                  ? `Int. ${clinicAddress.numeroInterior}`
                  : "",

              clinicAddress?.colonia,

              clinicAddress?.ciudad,

              clinicAddress?.estado,

              clinicAddress?.codigoPostal
                  ? `CP ${clinicAddress.codigoPostal}`
                  : ""

          ]

          .filter(Boolean)

          .join(", ");

  pdf.text(

      direccionTexto,

      55,

      26,

      {

          maxWidth: 135

      }

  );

  pdf.text(

    `Tel: ${clinicPhone || ""}`,

    55,

    32

  );

  pdf.text(

    `RFC: ${clinicRFC || ""}`,

    55,

    38

  );

  if (clinicEmail) {

    pdf.text(

      clinicEmail,

      55,

      44

    );

  }

  // =====================
  // LINEA DIVISORIA
  // =====================

  pdf.line(

    15,

    55,

    195,

    55

  );

// =====================
// TITULO
// =====================

pdf.setFontSize(16);

pdf.text(
  "RECIBO DE PAGO",
  15,
  68
);

pdf.setFontSize(10);

pdf.text(
  String(folio ?? ""),
  150,
  68
);

// =====================
// INFORMACION
// =====================

pdf.setFontSize(11);

pdf.text(
  "Paciente",
  15,
  90
);

pdf.setFontSize(13);

pdf.text(

  String(patientName ?? "")
    .replace(/\s+/g, " ")
    .trim(),

  15,

  98,

  {
    maxWidth: 170
  }

);

pdf.setFontSize(11);

pdf.text(
  "Tratamiento",
  15,
  113
);

pdf.setFontSize(13);

pdf.text(
  String(treatment ?? ""),
  15,
  121
);

// =====================
// RESUMEN FINANCIERO
// =====================

pdf.line(
  15,
  135,
  195,
  135
);

pdf.setFontSize(12);

// TOTAL TRATAMIENTO

pdf.text(
  "Total tratamiento",
  20,
  150
);

pdf.text(
  `$${Number(
    totalTreatment || 0
  ).toLocaleString("es-MX")}`,
  150,
  150
);

// PAGO RECIBIDO

pdf.text(
  "Pago recibido",
  20,
  160
);

pdf.text(
  `$${Number(
    paymentAmount || 0
  ).toLocaleString("es-MX")}`,
  150,
  160
);

// TOTAL PAGADO A LA FECHA

pdf.text(
  "Total pagado a la fecha",
  20,
  170
);

pdf.text(
  `$${Number(
    totalPaid || 0
  ).toLocaleString("es-MX")}`,
  150,
  170
);

// SALDO PENDIENTE

pdf.text(
  "Saldo pendiente",
  20,
  180
);

pdf.text(
  `$${Number(
    remainingBalance || 0
  ).toLocaleString("es-MX")}`,
  150,
  180
);

pdf.line(
  15,
  188,
  195,
  188
);

// =====================
// METODO DE PAGO
// =====================

pdf.setFontSize(11);

pdf.text(
  "Método de pago",
  15,
  202
);

pdf.setFontSize(13);

pdf.text(

  paymentMethod
    ? paymentMethod.charAt(0)
        .toUpperCase()
      +
      paymentMethod.slice(1)
    : "",

  15,

  210

);

// =====================
// FECHA
// =====================

pdf.setFontSize(11);

pdf.text(
  "Fecha",
  15,
  225
);

pdf.setFontSize(13);

pdf.text(
  String(paymentDate ?? ""),
  15,
  233
);

return pdf;

}
